<template>
  <div class="task-review-container">
    <!-- 搜索框 -->
    <el-form :inline="true"
             :model="searchForm"
             class="search-form">
      <el-form-item label="姓名">
        <el-input v-model="searchForm.name"
                  placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="账号">
        <el-input v-model="searchForm.account"
                  placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input v-model="searchForm.email"
                  placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="onSearch">搜索</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格容器，设置最大高度及滚动 -->
    <div class="table-container">
      <el-table :data="pagedData"
                border
                stripe
                style="width: 100%;"
                height="100%"
                class="custom-table">
        <el-table-column prop="id"
                         label="ID"
                         width="80"
                         align="center"></el-table-column>
        <el-table-column prop="name"
                         label="姓名"
                         width="120"
                         align="center"></el-table-column>
        <el-table-column prop="account"
                         label="账号"
                         width="150"
                         align="center"></el-table-column>
        <el-table-column prop="email"
                         label="邮箱"
                         width="180"
                         align="center"></el-table-column>
        <el-table-column prop="taskName"
                         label="任务名"
                         align="center"></el-table-column>
        <el-table-column label="作品展示"
                         width="180"
                         align="center">
          <template #default="{ row }">
            <div class="image-container">
              <img :src="row.imageUrl"
                  alt="作品展示"
                  class="work-image" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="submissionTime"
                         label="上交时间"
                         width="180"
                         align="center"></el-table-column>

        <!-- 审核状态 -->
        <el-table-column label="审核"
                         width="200"
                         align="center">
          <template #default="{ row }">
            <div class="audit-buttons">
              <el-button 
                type="success"
                size="mini"
                class="audit-btn"
                @click="handleAudit(row, 'pass')"
                :disabled="row.processState === 1">审核通过</el-button>
              <el-button 
                type="danger"
                size="mini"
                class="audit-btn"
                @click="handleAudit(row, 'fail')"
                :disabled="row.processState === 2">审核不通过</el-button>
            </div>
          </template>
        </el-table-column>

        <!-- 发布机器 -->
        <el-table-column label="发布机器"
                         width="120"
                         align="center">
          <template #default="{ row }">
            <el-button 
              type="primary"
              size="mini"
              class="download-btn"
              @click="handlePublishMachine(row)"
              :disabled="row.processState !== 1">
              {{ row.releasestate === 1 ? '已下载文件' : '下载文件' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[3, 6, 12]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="filteredData.length"
                    class="pagination" />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  data() {
    return {
      searchForm: {
        name: "",
        account: "",
        email: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 3,
    };
  },

  created() {
    this.fetchTaskData();
  },

  computed: {
    filteredData() {
      return this.tableData.filter((item) => {
        const { name, account, email } = this.searchForm;
        return (
          (!name || item.name.includes(name)) &&
          (!account || (item.account && item.account.includes(account))) &&
          (!email || (item.email && item.email.includes(email)))
        );
      });
    },
    pagedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = this.currentPage * this.pageSize;
      return this.filteredData.slice(start, end);
    },
  },

  methods: {
    onSearch() {
      this.currentPage = 1;
    },
    onReset() {
      this.searchForm.name = "";
      this.searchForm.account = "";
      this.searchForm.email = "";
      this.onSearch();
    },
    handleAudit(row, type) {
      const action = type === "pass" ? "通过" : "不通过";
      const processState = type === "pass" ? 1 : 2;
      
      this.$confirm(`确定审核${action}该作品吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const updateData = {
            id: row.id,
            processState: processState
          };
          
          request.post('/api/teachTask/updateProcessState', updateData)
            .then(response => {
              console.log('审核响应:', response);
              if (response.code === 0) {
                this.$message({
                  type: "success",
                  message: `审核${action}成功！`,
                });
                // 审核状态更新后立即刷新数据
                this.fetchTaskData();
              } else {
                this.$message.error(response.msg || `审核${action}失败`);
              }
            })
            .catch(error => {
              console.error('审核更新失败:', error);
              this.$message.error(`审核${action}失败`);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `已取消审核${action}`,
          });
        });
    },
    handlePublishMachine(row) {
      if (row.processState !== 1) {
        this.$message.warning('只有审核通过的作品才能发布机器');
        return;
      }

      const action = row.releasestate === 1 ? "已下载文件" : "下载文件";

      this.$confirm(`确定要${action}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (row.releasestate === 1) {
            row.releasestate = 0;
            this.$message.success('取消成功！');
          } else {
            this.savePublishedImage(row);
            row.releasestate = 1;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `已取消${action}`
          });
        });
    },
    handleSizeChange(size) {
      this.pageSize = size;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    },
    fetchTaskData() {
      const accountNumber = localStorage.getItem('userAccountNumber');
      request.get(`/api/teachTask/selectBytaskName?accountUser=${accountNumber}`)
        .then(response => {
          console.log('任务数据:', response);
          if (response.code === 0) {
            // 确保response.data是数组
            const taskData = Array.isArray(response.data) ? response.data : [response.data];
            this.tableData = taskData.map(item => ({
              id: item.id,
              name: item.studentName,
              taskName: item.taskName,
              imageUrl: `/resources/teacheTask/${item.studentUrl}`,
              submissionTime: this.formatDate(item.createTime),
              processState: item.processState,
              releasestate: item.releasestate,
              account: item.studentUser,
              email: item.email
            }));
          } else {
            this.$message.error(response.msg || '获取任务数据失败');
          }
        })
        .catch(error => {
          console.error('获取任务数据失败:', error);
          this.$message.error(error.message || '获取任务数据失败');
        });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getAuditStatus(processState) {
      switch (processState) {
        case 0:
          return '';
        case 1:
          return 'passed';
        case 2:
          return 'failed';
        default:
          return '';
      }
    },
    // 保存图片到本地
    savePublishedImage(task) {
      // 创建一个隐藏的 a 标签
      const downloadLink = document.createElement('a');
      downloadLink.href = task.imageUrl; // 使用图片URL
      
      // 从URL中获取文件名，如果没有则使用默认名称
      const fileName = task.imageUrl.split('/').pop() || `task_${task.id}.png`;
      downloadLink.download = fileName;
      
      // 添加到文档并触发点击
      document.body.appendChild(downloadLink);
      downloadLink.click();
      
      // 清理
      document.body.removeChild(downloadLink);

      this.$message.success('下载成功！图片已保存到本地。');
    }
  },
};
</script>

<style scoped>
.task-review-container {
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.search-form {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.search-form .el-form-item {
  margin-right: 15px;
  margin-bottom: 10px;
}

.search-form :deep(.el-input__inner) {
  border-radius: 4px;
}

.search-form .el-button {
  border-radius: 4px;
  padding: 8px 15px;
}

.table-container {
  height: 450px; /* 限制表格高度 */
  border-radius: 8px;
  overflow: hidden;
}

.custom-table {
  width: 100%;
  border: 1px solid #ebeef5;
}

.custom-table :deep(th) {
  background-color: #f5f7fa;
  color: #000000;
  font-weight: 500;
  padding: 12px 0;
  font-size: 18px;
}

.custom-table :deep(td) {
  padding: 12px 0;
}

.custom-table :deep(.el-table__row) {
  background-color: #ffffff;
}

.custom-table :deep(.el-table__row:nth-child(even)) {
  background-color: #f9f9f9;
}

.el-table__header-wrapper {
  background: #f3f3f3; /* 表头背景色 */
}

.work-image {
  width: 100px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #EAEAEA;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.audit-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
}

.audit-btn {
  margin: 0;
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 4px;
}

.audit-btn.el-button--success {
  background-color: #67c23a;
  border-color: #67c23a;
}

.audit-btn.el-button--danger {
  background-color: #f56c6c;
  border-color: #f56c6c;
}

.download-btn {
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 4px;
  background-color: #409eff;
  border-color: #409eff;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.pagination {
  padding: 0;
}

/* 媒体查询，用于不同屏幕宽度下设置不同的 pageSize */

@media (min-width: 1800px) {
 .table-container {
    height: 560px !important;
  }
}

@media (max-width: 1799px) {
 .table-container {
    max-height: 450px !important;
  }
}

</style>
